import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { EatingStyle } from '../types/onboarding'

const options: { value: EatingStyle; label: string; emoji: string }[] = [
  { value: 'home', label: 'Mostly cook at home', emoji: '🏠' },
  { value: 'mixed', label: 'Mix of home & eating out', emoji: '🔄' },
  { value: 'eating_out', label: 'Mostly eat out', emoji: '🍽️' },
  { value: 'meal_prep', label: 'Meal prep in batches', emoji: '📦' },
  { value: 'caregiver', label: 'Someone else cooks for me', emoji: '🤝' },
]

export function EatingStyleStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="How do you typically eat?"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.eatingStyle}
        onChange={(value) => goNext({ eatingStyle: value })}
      />
    </StepContainer>
  )
}
